/**
 * ArticleCta (G2, D9, S4): title + line + a link styled as a button. Spec §5.3 / D9: the button opens in the
 * SAME tab whatever its host (it leads to the product site); only an explicit target "new" opens a new tab
 * (I7). The band is the section's surfaceRole cta-band (PR5).
 */
import React, { memo } from 'react';
import type { ArticleBlockProps } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/types';
import { articleLinkTargetProps, resolveArticleHref } from '@modules/screen-view-v2/utils/articleLinks';
import { resolveLocaleText } from '@modules/screen-view-v2/utils/articleText';

export const ArticleCta = memo(function ArticleCta({ section, locale, article }: ArticleBlockProps): React.ReactElement | null {
  const content = section.articleCtaContent;
  if (!content) return null;
  const title = resolveLocaleText(content.title, locale);
  const sub = resolveLocaleText(content.sub, locale);
  const href = resolveArticleHref(content.button?.href);
  const buttonLabel = resolveLocaleText(content.button?.label, locale);
  return (
    <aside className="ap-block ap-cta" aria-label={title || undefined}>
      <div className="ap-cta-text">
        {title ? <p className="ap-cta-title">{title}</p> : null}
        {sub ? <p className="ap-cta-sub">{sub}</p> : null}
      </div>
      {href && buttonLabel ? (
        <a className="ap-cta-button" href={href} {...articleLinkTargetProps(href, content.button?.target ?? 'same', article.runtime?.siteOrigin)}>{buttonLabel}</a>
      ) : null}
    </aside>
  );
});

ArticleCta.displayName = 'ArticleCta';
